"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = EmptyMessage;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _searchIcon = _interopRequireDefault(require("./icons/searchIcon"));

var _styled = require("./styled");

function EmptyMessage(_ref) {
  var searchValue = _ref.searchValue;
  return _react["default"].createElement(_styled.MessageContainer, null, _react["default"].createElement(_searchIcon["default"], null), _react["default"].createElement(_styled.MessageDescription, null, "Our robots did not find any match for:"), _react["default"].createElement(_styled.MessageHighLight, null, " \u201C", searchValue, "\u201D"));
}

EmptyMessage.propTypes = {
  searchValue: _propTypes["default"].string
};
EmptyMessage.defaultProps = {
  searchValue: undefined
};